import React from 'react';
import useTheme from '@material-ui/core/styles/useTheme';
import { Checked } from '../icons';

interface Props {
  color?: string;
}

const CheckedListIcon: React.FC<Props> = ({ color }) => {
  const theme = useTheme();
  return <Checked width={15} height={15} color={color || theme.palette.secondary.main} />;
};

export default CheckedListIcon;
